/* eslint-disable no-undef */
export function identifyUserForCustomerIO(user) {
  if (typeof _cio !== "undefined") _cio.identify({ id: user?.uid, email: user?.email });
}
